<script setup lang="ts">
// import { showTurnstile } from '@/ui-plus/dialog/showTurnstile';
import { Button } from '@/components/ui/button'
import { AutoForm } from '@/ui-plus/auto-form'
import { toast } from '@/ui-plus/sonner'
import { useFormPlus } from "@/ui-plus/form/useFormPlus";
import { toTypedSchema } from "@vee-validate/zod";
import { authGlobalApiClient } from '@api-client/auth_global';
import { useForm } from "vee-validate";
import { z } from "zod";
import { Loader2 } from 'lucide-vue-next';
import { authState } from '@/ui-plus/useAuth';
import { startRefreshingTokens } from '@api-client/auth/auth';
import { useI18n } from "vue-i18n";
const { t } = useI18n();

withDefaults(defineProps<{
    showCancel?: boolean;
}>(), {
    showCancel: true,
});

const emit = defineEmits<{
    onSuccess: [values: z.infer<typeof schema>],
    onCancel: [],
    onError: [error: any],
}>();

const schema = z.object({
    newName: z.string()
        .min(1, { message: "min 1" })
        .max(255, { message: "max 255" }),
})

const form = useForm({
    validationSchema: toTypedSchema(schema)
});
const { isLoading, globalError, handleError, withSubmit } = useFormPlus(form);
form.setFieldValue("newName", authState.value.accessTokenPayload?.name || "");

async function onSubmit(values: z.infer<typeof schema>) {
    await withSubmit(async () => {
        const { error } = await (await authGlobalApiClient.user['update-name'].$post({
            form: {
                newName: values.newName,
                // turnstile: await showTurnstile(import.meta.env.PUBLIC_TURNSTILE_SITE_KEY)
            },
        })).json()
        if (error) {
            handleError(error, form);
        } else {
            await startRefreshingTokens();
            toast.success(t('nameUpdated'));
            emit("onSuccess", values);
        }
    })
}
</script>

<template>

    <AutoForm class="space-y-6"
              :schema="schema"
              :form="form"
              @submit="onSubmit"
              :field-config="{
                newName: {
                    label: t('yourName'),
                    inputProps: {
                        autofocus: true,
                        autocomplete: 'name',
                    },
                },
            }">
        <div class="text-sm font-medium text-destructive"
             v-if="globalError">
            {{ globalError }}
        </div>
        <div>
            <Button type="submit"
                    :disabled="isLoading"
                    class="w-full my-6">
                <Loader2 v-if="isLoading"
                         class="animate-spin" />
                {{ t('update') }}
            </Button>
        </div>
    </AutoForm>

    <Button v-if="showCancel"
            variant="secondary"
            @click="emit('onCancel')"> {{ t('cancel') }} </Button>
</template>
